export default {
  SET_ADDITIONAL_DATA(state, data) {
    state.additional_data = data
  },
}
